import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoBannerComponent } from './video-banner.component';
import { RouterModule } from '@angular/router';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { GenericLinkModule } from '@spartacus/storefront';

@NgModule({
  declarations: [VideoBannerComponent],
  imports: [CommonModule, RouterModule, GenericLinkModule],
  providers: [
    provideConfig({
      cmsComponents: {
        VideoBanners: {
          component: VideoBannerComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class VideoBannerModule {}
